class Common {
    constructor() {
        
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        
    }
}

export default Common;